import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PosthogService } from './posthog.service';

export const posthogEnabledGuard: CanActivateFn = () => {
  const posthog = inject(PosthogService);
  const router = inject(Router);
  return posthog.isEnabled ? true : router.parseUrl('/account/personal');
};
